
  import '/home/ec2-user/Youlify-Design/components/breadcrumb/index.$tab-design.zh-CN.md?watch=parent';
  export const texts = [{"value":"Breadcrumb的本质是了解当前所处页面的位置，并能向上导航。","paraId":0,"tocIndex":0}];
  